import Card from "../../../../components/ui/Card";

const DashboardCard = ({
  children,
  className = "",
  onClick,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <Card className={className} onClick={onClick}>
      {children}
    </Card>
  );
};
export default DashboardCard;
